import * as React from 'react'

import { useTimelineData } from '../context/DataContext'
import { WeeklyReducedRestBlock } from '../blocks/WeeklyReducedRestBlock'
import { LayerWrapper } from './LayerWrapper'
import { LayerProps } from './types'

const WeeklyReducedRestsLayer: React.FC<LayerProps> = ({ zIndex }) => {
  const { weeklyReducedRests } = useTimelineData()

  return (
    <LayerWrapper zIndex={zIndex}>
      {weeklyReducedRests.map((item, index) => (
        <WeeklyReducedRestBlock
          key={index}
          weeklyReducedRest={item}
          index={index}
        />
      ))}
    </LayerWrapper>
  )
}

export default WeeklyReducedRestsLayer
